<template>
  <div class="planner">
    <div class="planner-header">
      <h1 class="text-lg font-bold text-gray-900">Publication Planner</h1>
      <a href="/workbench" class="text-sm text-teal-600 hover:text-teal-800">Back to Workbench</a>
    </div>
    <div class="planner-body">
      <PlannerInput />
      <PlannerOutput />
    </div>
  </div>
</template>

<script setup>
import { provide, onMounted } from 'vue'
import { usePlannerStore } from '../../composables/usePlannerStore'
import PlannerInput from './PlannerInput.vue'
import PlannerOutput from './PlannerOutput.vue'

const props = defineProps({
  csrfToken: String,
})

const store = usePlannerStore(props.csrfToken)
provide('planner', store)

onMounted(() => {
  store.loadProjects()
})
</script>

<style scoped>
.planner {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

.planner-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1.5rem;
  border-bottom: 1px solid #e5e7eb;
  background: white;
  flex-shrink: 0;

  .dark & {
    background: #3C3C3C;
    border-bottom-color: #4A4A4A;
  }
}

.planner-body {
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
</style>
